import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './components/Auth/AuthContext';
import { LoadingProvider } from './components/Loading/LoadingContext';
import AgoraRTC, { AgoraRTCProvider } from "agora-rtc-react";
import { UserProvider } from './components/Auth/UsersContext';
import { PaymentSuccessProvider } from './components/Payment/PaymentStatusContext';

const originalLog = console.log;
const originalWarn = console.warn;
const originalError = console.error;

console.log = function (...args) {
  if (args[0] && typeof args[0] === "string" && args[0].includes("Agora-SDK"))
    return;
  originalLog.apply(console, args);
};
console.warn = function (...args) {
  if (args[0] && typeof args[0] === "string" && args[0].includes("Agora-SDK"))
    return;
  originalWarn.apply(console, args);
};
console.error = function (...args) {
  if (args[0] && typeof args[0] === "string" && args[0].includes("Agora-SDK"))
    return;
  originalError.apply(console, args);
};

// Suppress Agora SDK logs
AgoraRTC.setLogLevel && AgoraRTC.setLogLevel("none");
AgoraRTC.setLogLevel && AgoraRTC.setLogLevel(0);
const root = ReactDOM.createRoot(document.getElementById("root"));
const client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });


root.render(
  <React.StrictMode>
    <UserProvider>
      <AuthProvider>
        <LoadingProvider>
          <BrowserRouter>
            <AgoraRTCProvider client={client}>
              <PaymentSuccessProvider>
                <App />
              </PaymentSuccessProvider>
            </AgoraRTCProvider>
          </BrowserRouter>
        </LoadingProvider>
      </AuthProvider>
    </UserProvider>
  </React.StrictMode>
);
